import type { HealthStatus } from '../lib/api'

type Props = {
  status: HealthStatus['status'] | 'loading' | 'error'
  label?: string
}

const LABELS: Record<string, string> = {
  ok: 'Healthy',
  degraded: 'Degraded',
  down: 'Down',
  loading: 'Checking…',
  error: 'Unreachable',
}

export function HealthPill({ status, label }: Props) {
  const cls = status === 'ok' ? 'ok' : status === 'degraded' ? 'degraded' : status === 'down' || status === 'error' ? 'down' : ''
  return <span className={`pill ${cls}`}>{label ?? LABELS[status]}</span>
}
